import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.1313 0.901367L16.029 2.08597C16.0178 2.21553 16.0121 2.34687 16.0121 2.47979C16.0121 4.96789 18.0291 6.98489 20.5172 6.98489C20.6501 6.98489 20.7814 6.97917 20.911 6.96798L22.0956 6.8657L21.9933 8.0503C21.8458 9.75856 21.0391 11.2761 19.8311 12.3493C20.5702 13.2552 21.0167 14.4038 21.0167 15.6588C21.0167 17.871 19.634 19.7444 17.7014 20.5572L16.7796 20.9449L16.0042 19.1014L16.926 18.7137C18.1755 18.1881 19.0167 17.0041 19.0167 15.6588C19.0167 14.6066 18.5051 13.6582 17.6842 13.0396C17.5545 12.9419 17.4174 12.8527 17.2737 12.7729C16.7584 12.4868 16.1579 12.3214 15.5125 12.3214C15.5007 12.3214 15.4889 12.3215 15.4771 12.3216C15.4692 12.3217 15.4614 12.3218 15.4535 12.3219L14.5993 12.3352L14.4527 11.4935C14.1701 9.87034 12.8999 8.53412 11.2149 8.11784C10.8622 8.03072 10.4913 7.98406 10.1075 7.98406C10.0861 7.98406 10.0647 7.98421 10.0434 7.9845C7.60508 8.01758 5.70251 9.9216 5.70251 12.1889C5.70251 12.4514 5.72758 12.7074 5.77532 12.9552L5.95942 13.9106L5.00935 14.1208C3.83266 14.381 3 15.3817 3 16.5262C3 17.4741 3.56688 18.3187 4.43353 18.7334L5.33556 19.1651L4.47222 20.9692L3.57019 20.5375C2.06388 19.8166 1 18.3032 1 16.5262C1 14.6949 2.1256 13.1481 3.70819 12.4522C3.70441 12.3648 3.70251 12.277 3.70251 12.1889C3.70251 9.04272 6.1007 6.49027 9.16605 6.05095C9.77898 3.32609 12.1 1.24945 14.9467 1.00365L16.1313 0.901367ZM11.9961 13.9755H14V15.9794H11.9961V13.9755ZM7 15.9755H9.00391V17.9794H7V15.9755ZM12 18.9755H14.0039V20.9794H12V18.9755ZM7 20.9755H9.00391V22.9794H7V20.9755Z"}}]};

const CloudyNightRainFilled = Vue.extend<IconProps>({
  name: 'CloudyNightRainFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cloudy-night-rain-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CloudyNightRainFilled;
